import { useEffect, useState } from "react";
import { TrendingUp } from "lucide-react";
import api from "@/lib/api";

export default function TrendingTicker() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let active = true;
    const load = () => api.get("/news/trending").then(({ data }) => { if (active) setItems(data.items || []); }).catch(() => {});
    load();
    const t = setInterval(load, 5 * 60 * 1000);
    return () => { active = false; clearInterval(t); };
  }, []);

  if (!items.length) return null;
  const loop = [...items, ...items];

  return (
    <div className="h-9 bg-[#111110] text-white flex items-center overflow-hidden shrink-0" data-testid="trending-ticker">
      <div className="flex items-center gap-2 bg-[#ffce00] text-black h-full px-3 shrink-0 z-10">
        <TrendingUp className="w-3.5 h-3.5" aria-hidden="true" />
        <span className="font-mono text-[10px] uppercase tracking-wider font-bold">Trending</span>
      </div>
      <div className="relative flex-1 overflow-hidden">
        <div className="flex whitespace-nowrap animate-marquee">
          {loop.map((it, i) => (
            <a
              key={i}
              href={it.link}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-6 text-xs font-mono hover:text-[#ffce00] transition-colors"
            >
              <span className="text-[#ffce00]">•</span>
              <span className="text-white/50">[{it.category_label}]</span>
              <span>{it.title}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
